/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';
import FilterToolIcon from 'icons/FilterToolIcon';

const messages = defineMessages({
  title: {id: 'navigation.data-tools.filter'},
});

const FilterItem = () => (
  <RouteLinkItem
    iconBefore={FilterToolIcon}
    route="midas/data-tools/filter-tool"
    title={messages.title}
  />
);

export default FilterItem;
